import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminProductsByRetailer from "@/pages/admin/AdminProductsByRetailer";

export const Route = createFileRoute("/admin/products-by-retailer")({
  component: () => (
    <ProtectedRoute>
      <AdminProductsByRetailer />
    </ProtectedRoute>
  ),
});
